export const AuthActionTypes = {
   LOGIN: 'LOGIN',
   LOGIN_PENIDNG: 'LOGIN_PENDING',
   LOGIN_FULFILLED: 'LOGIN_FULFILLED',

   SIGNUP: 'SIGNUP',
   SIGNUP_PENDING: 'SIGNUP_PENDING',
   SIGNUP_FULFILLED: 'SIGNUP_FULFILLED',

   FORGOTPASSWORD: 'FORGOTPASSWORD',
   FORGOTPASSWORD_PENDING: 'FORGOTPASSWORD_PENDING',
   FORGOTPASSWORD_FULFILLED: 'FORGOTPASSWORD_FULFILLED',

   RESETPASSWORD: 'RESETPASSWORD',
   RESETPASSWORD_PENDING: 'RESETPASSWORD_PENDING',
   RESETPASSWORD_FULFILLED: 'RESETPASSWORD_FULFILLED',

   VERIFICATION: 'VERIFICATION',
   VERIFICATION_PENDING: 'VERIFICATION_PENDING',
   VERIFICATION_FULFILLED: 'VERIFICATION_FULFILLED',

   RESENDVERIFICATION: 'RESENDVERIFICATION',
   RESENDVERIFICATION_PENDING: 'RESENDVERIFICATION_PENDING',
   RESENDVERIFICATION_FULFILLED: 'RESENDVERIFICATION_FULFILLED',

   USERAPI: 'USERAPI',
   USERAPI_PENDING: 'USERAPI_PENDING',
   USERAPI_FULFILLED: 'USERAPI_FULFILLED',

   LOGOUT: 'LOGOUT',
   LOGOUT_PENDING: 'LOGOUT_PENDING',
   LOGOUT_FULFILLED: 'LOGOUT_FULFILLED',

   PROFILE: 'PROFILE',
   PROFILE_PENDING: 'PROFILE_PENDING',
   PROFILE_FULFILLED: 'PROFILE_FULFILLED',

   ADDCARD: 'ADDCARD',
   ADDCARD_PENDING: 'ADDCARD_PENDING',
   ADDCARD_FULFILLED: 'ADDCARD_FULFILLED',

   PLANS: 'PLANS',
   PLANS_PENDING: 'PLANS_PENDING',
   PLANS_FULFILLED: 'PLANS_FULFILLED',

   PLANID: 'PLANID',
   PLANID_PENDING: 'PLANID_PENDING',
   PLANID_FULFILLED: 'PLANID_FULFILLED',

   PLANNAME: 'PLANNAME',
   PLANNAME_PENDING: 'PLANNAME_PENDING',
   PLANNAME_FULFILLED: 'PLANNAME_FULFILLED',

   PLANPRICE: 'PLANPRICE',
   PLANPRICE_PENDING: 'PLANPRICE_PENDING',
   PLANPRICE_FULFILLED: 'PLANPRICE_FULFILLED',

   SUBSCRIBE: 'SUBSCRIBE',
   SUBSCRIBE_PENDING: 'SUBSCRIBE_PENDING',
   SUBSCRIBE_FULFILLED: 'SUBSCRIBE_FULFILLED',

   GETSUB: 'GETSUB',
   GETSUB_PENDING: 'GETSUB_PENDING',
   GETSUB_FULFILLED: 'GETSUB_FULFILLED',

   UPLOAD_PHOTO_TO_S3_BUCKET: 'UPLOAD_PHOTO_TO_S3BUCKET',
   UPLOAD_PHOTO_TO_S3_BUCKET_PENDING: 'UPLOAD_PHOTO_TO_S3BUCKET_PENDING',
   UPLOAD_PHOTO_TO_S3_BUCKET_FULFILLED: 'UPLOAD_PHOTO_TO_S3BUCKET_FULFILLED',

   UPLOAD_PHOTO: 'UPLOAD_PHOTO',
   UPLOAD_PHOTO_PENDING: 'UPLOAD_PHOTO_PENDING',
   UPLOAD_PHOTO_FULFILLED: 'UPLOAD_PHOTO_FULFILLED',

   CANCELSUB: 'CANCELSUB',
   CANCELSUB_PENDING: 'CANCELSUB_PENDING',
   CANCELSUB_FULFILLED: 'CANCELSUB_FULFILLED',

   UPDATE_TOKEN: 'UPDATE_TOKEN',

   COUPONCHECK: 'COUPONCHECK',
   COUPONCHECK_PENDING: 'COUPONCHECK_PENDING',
   COUPONCHECK_FULFILLED: 'COUPONCHECK_FULFILLED',

   CLEARCOUPON: 'CLEARCOUPON',
   CLEARCOUPON_PENDING: 'CLEARCOUPON_PENDING',
   CLEARCOUPON_FULFILLED: 'CLEARCOUPON_FULFILLED',
};
